const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

class StauffApiService {
  async searchParts(partNumber) {
    try {
      const response = await fetch(`${API_BASE_URL}/stauff/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ partNumber })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Stauff search error:', error);
      throw error;
    }
  }

  async checkAvailability(sku, quantity = 1) {
    try {
      const response = await fetch(`${API_BASE_URL}/stauff/availability`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sku, quantity })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Stauff availability error:', error);
      throw error;
    }
  }

  async searchWithAvailability(partNumber, quantity = 1) {
    try {
      const response = await fetch(`${API_BASE_URL}/stauff/search-with-availability`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ partNumber, quantity })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Stauff combined search error:', error);
      throw error;
    }
  }

  async checkCombinedStock(partNumber, quantity = 1) {
    try {
      const response = await fetch(`${API_BASE_URL}/stauff/combined-stock-check`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ partNumber, quantity })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Combined stock check error:', error);
      throw error;
    }
  }
}

export default new StauffApiService();
